import type { LucideIcon } from "lucide-react";
import { cn } from "../lib/cn";

export function PageHeader({
  title,
  subtitle,
  icon: Icon,
  actions,
  className,
}: {
  title: string;
  subtitle?: React.ReactNode;
  icon?: LucideIcon;
  actions?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex items-end justify-between gap-3 px-5 pt-5 pb-3", className)}>
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          {Icon && <Icon className="size-4 text-fg-subtle" />}
          <h1 className="text-lg font-semibold text-fg leading-none">{title}</h1>
        </div>
        {subtitle && <div className="mt-1 text-xs text-fg-muted">{subtitle}</div>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>
  );
}

export function PageBody({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={cn("px-5 pb-6", className)}>{children}</div>;
}

export function PageStub({ title, icon: Icon, subtitle }: { title: string; icon: LucideIcon; subtitle?: string }) {
  return (
    <>
      <PageHeader title={title} icon={Icon} subtitle={subtitle} />
      <PageBody>
        <div className="panel py-16 text-center">
          <Icon className="size-8 text-fg-subtle mx-auto mb-3" />
          <h3 className="text-base font-semibold text-fg">Coming up next</h3>
          <p className="text-sm text-fg-muted mt-1">
            This page is being rebuilt in the v2 design.
          </p>
        </div>
      </PageBody>
    </>
  );
}
